import { useSearchParams } from 'react-router';
import { listCases } from '@/lib/cases-list/api';
import type { CaseBucket, CaseFilters, CaseRow } from '@/lib/cases-list/types';
import { airportsCsv, useAirportScope } from '@/lib/operator-context/airport-scope';
import { useInfiniteList } from '@/lib/pagination/use-infinite-list';

// Reads filters from the URL via useSearchParams (TDS §4.1: filter state
// survives reload). The header airport scope (NEX-310) rides in via
// useAirportScope (URL ?airports= with the stored fallback) so the list
// narrows wherever the operator set the scope. Cursor-paginated via the
// canonical useInfiniteList hook (frontend-conventions §7.5) — the list no
// longer unbounded-fetches; it walks pages as the operator scrolls.
// staleTime 30s per §6.2.

export function useCasesList(opts: { bucket?: CaseBucket; archived?: boolean } = {}) {
  const [params] = useSearchParams();
  const { airports } = useAirportScope();
  const filters: CaseFilters = {
    airport: params.get('airport') || undefined,
    airports: airportsCsv(airports),
    status: params.get('status') || undefined,
    from: params.get('from') || undefined,
    to: params.get('to') || undefined,
    bucket: opts.bucket,
    archived: opts.archived,
  };
  return useInfiniteList<CaseRow, CaseFilters>({
    baseKey: ['cases'],
    filters,
    queryFn: (f, cursor) => listCases(f, cursor),
    staleTime: 30_000,
  });
}
